import React from 'react'

import PaymentProvider from './payment-provider'

export default function withPayment (WrappedComponent) {
  return function PaymentProviderHOC(props) {
    return (
      <PaymentProvider>
        <WrappedComponent {...props} />
      </PaymentProvider>
    )
  }
}